import { SortFieldParams } from '@crx-dev/hss-react-components';
import { useQueryParamsState } from './useQueryParamsState';

interface PageState {
    page: number;
    pageSize: number;
    sortDirection: 'asc' | 'desc';
    sortField: string;
    search: string;
}

interface UsePaginationInUrlReturnValue {
    pageState: PageState;
    // setQueryParam: <U extends keyof T>(field: U, value: T[U]) => void;
    actions: UsePaginationInUrlActions;
}

interface UsePaginationInUrlActions {
    setSort: (sortParams: SortFieldParams) => void;
    setPage: (page: number) => void;
    setPageSize: (pageSize: number) => void;
    setSearch: (search: string) => void;
    // setValues: (values: Partial<T>) => void;
    setValues: (values: any) => void; // todo fix type
}

export function usePaginationInUrl(defaults: Partial<PageState>): UsePaginationInUrlReturnValue {
    const { queryParams, setQueryParams } = useQueryParamsState<PageState>({
        page: defaults.page ?? 0,
        pageSize: defaults.pageSize ?? 10,
        sortField: defaults.sortField,
        sortDirection: defaults.sortDirection ?? 'asc'
    });

    return {
        // @ts-ignore
        pageState: queryParams,
        actions: {
            setPage: (page: number) => {
                setQueryParams({ page });
            },
            setPageSize: (pageSize: number) => {
                setQueryParams({
                    pageSize,
                    page: 0
                });
            },
            setSort: (sortParams: SortFieldParams) => {
                setQueryParams({
                    sortField: sortParams.field,
                    sortDirection: sortParams.direction,
                    page: 0
                });
            },
            setSearch: (search: string) => {
                setQueryParams({
                    search,
                    page: 0
                });
            },
            // todo fix type
            // setValues: (values: Partial<T>) => {
            setValues: (values: any) => {
                setQueryParams({
                    page: 0,
                    ...values
                });
            }
        }
    };
}
